/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { isIOS, isMobile, withOrientationChange } from 'react-device-detect';
// import Header from './header';
import { configStyle, obtenerValorConfig, positionDiv } from './utilities/styles/configStyle';
import { evento, sendEventClick } from './utilities/events/eventos';
import { generarObjetoLifeCycle, enviarImagenIdentificacion, extraerOCR, extraerOCRCompleto, mapearOCR, generateZip, flowIncompleted, validarRedireccionamiento } from './services/data';
import { mapearRespuesta, mapearError } from './utilities/response/map_response';
import Ayuda from '../../pages/ayuda';
import ComponenteRecorte from './componente_recorte';
import LoaderOCR from './loaderOCR';
// import MultiCamara from './multi_camara';
import OverlayCargandoCamara from './overlay_cargando_camara';
import AlertaValidacionDimensiones from './alerta_validacion_dimensiones';
import CancelarFlujo from '../cancelar_flujo';
import Loader from '../loader';

const urlCreator = window.URL || window.webkitURL;
let stream = null

const ComponenteCapturaIdentificacion = (props) => {

    const { uuidTransaccion, apikey, isLandscape, dataOtorgante, fullOcr, ocr, classify, nextStep } = props;
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    // const [isStart, setIsStart] = useState(true);
    const [side, setSide] = useState('front');
    const [proccessing, setProccessing] = useState(false);
    const [desktop, setDesktop] = useState(false);
    const [showIdOverlay, setShowIdOverlay] = useState(false);
    const [intentsFront, setIntentsFront] = useState(0);
    const [intentsBack, setIntentsBack] = useState(0);
    const [intentosFrente, setIntentosFrente] = useState(0);
    const [intentosReverso, setIntentosReverso] = useState(0);
    const [hasResponse, setHasResponse] = useState(false);
    const [hasFace, setHasFace] = useState(false);
    const [isPassport, setIsPassport] = useState(false);
    const [intentsData, setIntentsData] = useState(false);
    const [errorF, setErrorF] = useState('');
    const [errorMsg, setErrorMsg] = useState(false);
    const [errorVideo, setErrorVideo] = useState(false);
    const [previewId, setPreviewId] = useState(false);
    const [imageUrl, setImageUrl] = useState('');
    const [capturing, setCapturing] = useState(false);
    const [errorCapture, setErrorCapture] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showHelp, setShowHelp] = useState(false);
    const [dataResponse, setDataResponse] = useState(null);
    const [pathname, setPathname] = useState('');
    const [dispositivosVideo, setDispositivosVideo] = useState([]);
    const [showSelect, setShowSelect] = useState(false);
    // const [dispositivoActual, setDispositivosActual] = useState('')
    // const [msjMultiCamaras, setMsjMultiCamaras] = useState(false)
    const [showCancelScreen, setShowCancelScreen] = useState(false);
    const [onLoadViewCamera, setOnLoadViewCamera] = useState(true);
    const [imageURL, setImageURL] = useState()
    const [showAlertDimensions, setShowAlertDimensions] = useState(false)
    const [disableFinishButton, setDisableFinishButton] = useState(true)
    const [mostrarLoader, setMostrarLoader] = useState(false)
    const refCanvas = useRef(null);
    const refVideo = useRef(null);
    const refDivFooter = useRef(null);
    const refButtonCapture = useRef(null);
    const refCanvasMask = useRef(null);
    const refContainerCanvasMask = useRef(null);

    useEffect(() => {
        if (!isMobile) {
            setDesktop(true);
            //setIsStart(true);
            refVideo.current.classList.add('myVideo_rotate');
        }

        setPathname(window.location.pathname);

        // localStorage.removeItem("camarasList");

        iniciarCaptura();
        permisoCamara();

        return () => {
            if (stream) stream.getTracks().forEach(track => track.stop());
            // localStorage.removeItem("camarasList");
        }
    }, []);

    useEffect(() => {
        if (props.dataOtorgante.length > 0) {
            configStyle(props.dataOtorgante);

            let bloqueo = localStorage.getItem('bloqueo');
            if (!bloqueo) {
                localStorage.setItem('bloqueo', 'false');
            } else {
                if (bloqueo === 'true') {
                    setDisableFinishButton(false)
                    setIntentsFront(Number(obtenerValorConfig(props.dataOtorgante, 'INTENTOS_ID_FRONTAL', '3')));
                }
            }

            setIntentosFrente(Number(obtenerValorConfig(props.dataOtorgante, 'INTENTOS_ID_FRONTAL', '3')));
            setIntentosReverso(Number(obtenerValorConfig(props.dataOtorgante, 'INTENTOS_ID_REVERSO', '3')));
        }

        if (props.apikey && props.uuidTransaccion && props.uuidUser && props.nombreOtorgante)
            generarObjetoLifeCycle('paso', { status: 'OK', step: 'captura_id_page', stepEvent: 'Captura ID' }, props);
        return () => { };
    }, [props]);

    useEffect(() => {
        if (refDivFooter.current) refDivFooter.current.style.position = positionDiv(window.innerWidth, window.innerHeight);
        return () => { };
    }, [refDivFooter]);

    useEffect(() => {
        if (intentsData > 0 && errorF) {
            enviarReintento('Reintento Captura ID', errorF);
        }
        return () => { };
    }, [intentsData, errorF]);

    useEffect(() => {
        if (intentsFront > 0 && errorF) {
            enviarReintento('Intentos Captura ID Frente', intentsFront);
            if (intentsFront === intentosFrente) {
                finalizarFlujo();
            } else {
                enviarReintento('Reintento Captura ID', errorF);
            }
        }
        return () => { };
    }, [intentsFront, errorF]);

    useEffect(() => {
        if (intentsBack > 0 && errorF) {
            enviarReintento('Intentos Captura ID Reverso', intentsBack);
            if (intentsBack === intentosReverso) {
                sendData();
                setTimeout(() => {
                    history.push({
                        pathname: nextStep,
                        state: { passport: false }
                    })
                }, 300);
            } else {
                enviarReintento('Reintento Captura ID', errorF);
            }
        }
        return () => { };
    }, [intentsBack, errorF]);

    useEffect(() => {
        if (!previewId && !isLandscape) {
            /* Dibujar bordes máscara identificación */
            if (isMobile) {
                resizeCanvas();
                let contextCanvas = refCanvasMask.current.getContext('2d');
                /* Inserción de imágenes para guía */
                // if (side === 'front') {
                //     const icon_man = new Image();
                //     const icon_stripes = new Image();
                //     icon_man.addEventListener(
                //         'load',
                //         () => {
                //             if (window.innerWidth <= 424 && window.innerWidth > 412) {
                //                 if (window.innerHeight >= 839) {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 10) / 100), 0, ((refCanvasMask.current.width * 80) / 100), ((refCanvasMask.current.height * 50) / 100));
                //                 } else if (window.innerHeight < 669) {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 10) / 100), 0, ((refCanvasMask.current.width * 75) / 100), ((refCanvasMask.current.height * 55) / 100));
                //                 } else {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 10) / 100), 0, ((refCanvasMask.current.width * 75) / 100), ((refCanvasMask.current.height * 52) / 100));
                //                 }
                //             } else if (window.innerWidth <= 412 && window.innerWidth > 393) {
                //                 if (window.innerHeight >= 800) {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 7) / 100), 0, ((refCanvasMask.current.width * 90) / 100), ((refCanvasMask.current.height * 50) / 100));
                //                 } else if (window.innerHeight === 718) {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 10) / 100), 0, ((refCanvasMask.current.width * 82) / 100), ((refCanvasMask.current.height * 55) / 100));
                //                 } else {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 10) / 100), 0, ((refCanvasMask.current.width * 82) / 100), ((refCanvasMask.current.height * 55) / 100));
                //                 }
                //             } else if (window.innerWidth <= 393 && window.innerWidth > 375) {
                //                 if (window.innerHeight > 560) {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 13) / 100), 5, ((refCanvasMask.current.width * 80) / 100), ((refCanvasMask.current.height * 50) / 100));
                //                 } else {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 13) / 100), 5, ((refCanvasMask.current.width * 80) / 100), ((refCanvasMask.current.height * 55) / 100));
                //                 }
                //             } else if (window.innerWidth === 375) {
                //                 if (window.innerHeight < 667) {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 10) / 100), 0, ((refCanvasMask.current.width * 75) / 100), ((refCanvasMask.current.height * 55) / 100));
                //                 } else {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 10) / 100), 0, ((refCanvasMask.current.width * 75) / 100), ((refCanvasMask.current.height * 50) / 100));
                //                 }
                //             } else if (window.innerWidth === 360) {
                //                 if (window.innerHeight >= 764) {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 10) / 100), 10, ((refCanvasMask.current.width * 80) / 100), ((refCanvasMask.current.height * 48) / 100));
                //                 } else if (window.innerHeight === 740) {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 10) / 100), 5, ((refCanvasMask.current.width * 85) / 100), ((refCanvasMask.current.height * 53) / 100));
                //                 } else if (window.innerHeight <= 708 && window.innerHeight > 664) {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 10) / 100), 0, ((refCanvasMask.current.width * 80) / 100), ((refCanvasMask.current.height * 53) / 100));
                //                 } else if (window.innerHeight <= 664 && window.innerHeight > 588) {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 10) / 100), 0, ((refCanvasMask.current.width * 80) / 100), ((refCanvasMask.current.height * 55) / 100));
                //                 } else if (window.innerHeight === 588) {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 10) / 100), 3, ((refCanvasMask.current.width * 77) / 100), ((refCanvasMask.current.height * 55) / 100));
                //                 } else {
                //                     contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 10) / 100), 0, ((refCanvasMask.current.width * 80) / 100), ((refCanvasMask.current.height * 55) / 100));
                //                 }
                //             } else {
                //                 contextCanvas.drawImage(icon_man, ((refCanvasMask.current.width * 10) / 100), 0, ((refCanvasMask.current.width * 80) / 100), ((refCanvasMask.current.height * 50) / 100));
                //             }
                //         },
                //         false
                //     );
                //     icon_stripes.addEventListener(
                //         'load',
                //         () => {
                //             if (window.innerWidth <= 424 && window.innerWidth > 412) {
                //                 if (window.innerHeight < 669) {
                //                     contextCanvas.drawImage(icon_stripes, ((refCanvasMask.current.width * 38) / 100), ((refCanvasMask.current.height * 40) / 100), ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 58) / 100));
                //                 } else {
                //                     contextCanvas.drawImage(icon_stripes, ((refCanvasMask.current.width * 38) / 100), ((refCanvasMask.current.height * 40) / 100), ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 57) / 100));
                //                 }
                //             } else if (window.innerWidth <= 412 && window.innerWidth > 393) {
                //                 if (window.innerHeight >= 800) {
                //                     contextCanvas.drawImage(icon_stripes, ((refCanvasMask.current.width * 35) / 100), ((refCanvasMask.current.height * 40) / 100), ((refCanvasMask.current.width * 50) / 100), ((refCanvasMask.current.height * 60) / 100));
                //                 } else if (window.innerHeight >= 718) {
                //                     contextCanvas.drawImage(icon_stripes, ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 43) / 100), ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 55) / 100));
                //                 } else {
                //                     contextCanvas.drawImage(icon_stripes, ((refCanvasMask.current.width * 45) / 100), ((refCanvasMask.current.height * 38) / 100), ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 60) / 100));
                //                 }
                //             } else if (window.innerWidth <= 393 && window.innerWidth > 375) {
                //                 if (window.innerHeight > 560) {
                //                     contextCanvas.drawImage(icon_stripes, ((refCanvasMask.current.width * 43) / 100), ((refCanvasMask.current.height * 40) / 100), ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 57) / 100));
                //                 } else {
                //                     contextCanvas.drawImage(icon_stripes, ((refCanvasMask.current.width * 43) / 100), ((refCanvasMask.current.height * 43) / 100), ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 54) / 100));
                //                 }
                //             } else if (window.innerWidth === 375) {
                //                 if (window.innerHeight < 667) {
                //                     contextCanvas.drawImage(icon_stripes, ((refCanvasMask.current.width * 38) / 100), ((refCanvasMask.current.height * 42) / 100), ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 55) / 100));
                //                 } else {
                //                     contextCanvas.drawImage(icon_stripes, ((refCanvasMask.current.width * 38) / 100), ((refCanvasMask.current.height * 40) / 100), ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 58) / 100));
                //                 }
                //             } else if (window.innerWidth <= 360) {
                //                 if (window.innerHeight >= 764) {
                //                     contextCanvas.drawImage(icon_stripes, ((refCanvasMask.current.width * 38) / 100), ((refCanvasMask.current.height * 41) / 100), ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 55) / 100));
                //                 } else if (window.innerHeight <= 708 && window.innerHeight > 664) {
                //                     contextCanvas.drawImage(icon_stripes, ((refCanvasMask.current.width * 42) / 100), ((refCanvasMask.current.height * 41) / 100), ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 55) / 100));
                //                 } else if (window.innerHeight >= 664 && window.innerHeight < 708) {
                //                     contextCanvas.drawImage(icon_stripes, ((refCanvasMask.current.width * 45) / 100), ((refCanvasMask.current.height * 42) / 100), ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 55) / 100));
                //                 } else if (window.innerHeight === 588) {
                //                     contextCanvas.drawImage(icon_stripes, ((refCanvasMask.current.width * 42) / 100), ((refCanvasMask.current.height * 42) / 100), ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 56) / 100));
                //                 } else {
                //                     contextCanvas.drawImage(icon_stripes, ((refCanvasMask.current.width * 42) / 100), ((refCanvasMask.current.height * 42) / 100), ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 54) / 100));
                //                 }
                //             } else {
                //                 contextCanvas.drawImage(icon_stripes, ((refCanvasMask.current.width * 45) / 100), ((refCanvasMask.current.height * 38) / 100), ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 60) / 100));
                //             }
                //         },
                //         false
                //     );
                //     icon_man.src = '/images/componente_captura_identificacion/man_ico_f@2x.png';
                //     icon_stripes.src = '/images/componente_captura_identificacion/lines_ico_f@2x.png';
                // } else {
                //     const icon_cbar = new Image();
                //     const icon_stripes = new Image();
                //     const icon_qr = new Image();
                //     icon_cbar.addEventListener(
                //         'load',
                //         () => {
                //             contextCanvas.drawImage(icon_cbar, ((refCanvasMask.current.width * 75) / 100), 0, ((refCanvasMask.current.width * 28) / 100), ((refCanvasMask.current.height * 30) / 100));
                //         },
                //         false
                //     );
                //     icon_stripes.addEventListener(
                //         'load',
                //         () => {
                //             contextCanvas.drawImage(icon_stripes, 0, 0, ((refCanvasMask.current.width * 45) / 100), ((refCanvasMask.current.height * 100) / 100));
                //         },
                //         false
                //     );
                //     icon_qr.addEventListener(
                //         'load',
                //         () => {
                //             contextCanvas.drawImage(icon_qr, ((refCanvasMask.current.width * 50) / 100), ((refCanvasMask.current.height * 66) / 100), ((refCanvasMask.current.width * 40) / 100), ((refCanvasMask.current.height * 28) / 100));
                //         },
                //         false
                //     );
                //     icon_cbar.src = '/images/componente_captura_identificacion/cbar_ico_b@2x.png';
                //     icon_stripes.src = '/images/componente_captura_identificacion/lines_ico_b@2x.png';
                //     icon_qr.src = '/images/componente_captura_identificacion/qrr_ico_b@2x.png';
                // }

                contextCanvas.beginPath();
                /* Lado superior */
                /* contextCanvas.roundRect(0, 20, (refCanvasMask.current.width - 4), (refCanvasMask.current.height - 52), [20]);
                contextCanvas.lineWidth = 35;
                contextCanvas.strokeStyle = '#ff0000'; 
                contextCanvas.stroke();*/
                contextCanvas.moveTo((refCanvasMask.current.width * 2.3 / 100), 0);
                //contextCanvas.lineTo(0, 100);
                contextCanvas.lineTo((refCanvasMask.current.width * 2.3 / 100), refCanvasMask.current.height);
                contextCanvas.moveTo((refCanvasMask.current.width * 2.3 / 100), 0);
                // contextCanvas.moveTo(0, -8);
                // contextCanvas.lineTo(150, -8);
                //contextCanvas.lineTo(refCanvasMask.current.width, -8);
                contextCanvas.lineTo(refCanvasMask.current.width, 0);
                contextCanvas.moveTo((refCanvasMask.current.width * 98 / 100), 0);
                // contextCanvas.lineTo((refCanvasMask.current.width), 100);
                contextCanvas.lineTo((refCanvasMask.current.width * 98 / 100), refCanvasMask.current.height);
                // contextCanvas.moveTo(refCanvasMask.current.width, -8);
                // contextCanvas.lineTo((refCanvasMask.current.width - 150), -8);
                /* Lado inferior */
                contextCanvas.moveTo(0, refCanvasMask.current.height);
                //contextCanvas.lineTo(0, (refCanvasMask.current.height - 100));
                contextCanvas.lineTo(refCanvasMask.current.height, (refCanvasMask.current.width));
                // contextCanvas.moveTo(0, (refCanvasMask.current.height + 8));
                // contextCanvas.lineTo(150, (refCanvasMask.current.height + 8));
                // contextCanvas.moveTo((refCanvasMask.current.width), refCanvasMask.current.height);
                // contextCanvas.lineTo((refCanvasMask.current.width), (refCanvasMask.current.height - 100));
                // contextCanvas.moveTo(refCanvasMask.current.width, (refCanvasMask.current.height + 8));
                // contextCanvas.lineTo((refCanvasMask.current.width - 150), (refCanvasMask.current.height + 8));
                contextCanvas.lineWidth = 80;
                contextCanvas.strokeStyle = 'rgba(255, 255, 255, 0.5)';
                contextCanvas.stroke();
                contextCanvas.closePath();
            }
            else {
                let contextCanvas = refCanvasMask.current.getContext('2d');
                contextCanvas.beginPath();
                /* Lado superior */
                contextCanvas.roundRect(0, 0, (refCanvasMask.current.width - 4), (refCanvasMask.current.height - 0), [10]);
                contextCanvas.moveTo((refCanvasMask.current.width * 2.3 / 100), 0);
                contextCanvas.lineTo((refCanvasMask.current.width * 2.3 / 100), refCanvasMask.current.height);
                contextCanvas.moveTo((refCanvasMask.current.width * 2.3 / 100), 0);
                contextCanvas.lineTo(refCanvasMask.current.width, 0);
                contextCanvas.moveTo((refCanvasMask.current.width * 98 / 100), 0);
                contextCanvas.lineTo((refCanvasMask.current.width * 98 / 100), refCanvasMask.current.height);
                /* Lado inferior */
                contextCanvas.moveTo(0, refCanvasMask.current.height);
                contextCanvas.lineTo(refCanvasMask.current.height, (refCanvasMask.current.width));
                contextCanvas.lineWidth = 10;
                contextCanvas.strokeStyle = 'rgba(255, 255, 255, 0.5)';
                contextCanvas.stroke();
                contextCanvas.closePath();
            }

        }
        return () => { };
    }, [previewId, isLandscape, side]);

    useEffect(() => {
        if (imageURL) {
            let a = document.createElement('a');
            document.body.appendChild(a);
            a.style = 'display: none';
            a.href = imageURL;
            a.download = 'captura_ine.png';
            a.click();
        }
    }, [imageURL]);

    useEffect(() => {
        setShowIdOverlay(desktop ? true : false);
    }, [desktop]);

    const iniciarCaptura = () => {
        //sendEventClick('Captura ID', 'CONTINUAR', {}, props);
        //setIsStart(false);
        //setShowIdOverlay(desktop ? true : false);
        refVideo.current.classList.remove('blur_video');
    }

    const permisoCamara = () => {
        const deviceId = localStorage.getItem('deviceId');
        configure(deviceId);
        /* let deviceFuncional = '';
        navigator.mediaDevices.getUserMedia({video:true}).then(mediaStream =>{
            navigator.mediaDevices.enumerateDevices().then(function (devices) {
                evento('Captura ID', 'User Media Component', { status: devices }, true, props)
                for (let i = 0; i < devices.length; i++) {
                    let device = devices[i];
                    if (device.kind === 'videoinput') {
                        if ((device.label).includes('back')) {
                            if ((device.label).includes('0')) {
                                deviceFuncional = device.deviceId;
                            }
                        }
                    }
                }
                evento('Captura ID', 'User Media Component', { deviceFuncional: deviceFuncional }, true, props)
                start(deviceFuncional);
                if (mediaStream) mediaStream.getTracks().forEach(track => track.stop());
            });
        }).catch(handleErrorMediaUser) */
    }

    /*const start = (deviceFuncional) => {

        if (stream) {
            stream.getTracks().forEach(track => {
                track.stop();
            })
        }

        let lista = localStorage.getItem('camarasList')

        if (isMobile && (!deviceFuncional || !isIOS) && !lista) {
            let arrayLista = [];
            navigator.mediaDevices.enumerateDevices().then((devices) => {
                evento('Captura ID', 'User Media Component', { status: devices }, true, props)
                for (var i = 0; i < devices.length; i++) {
                    var device = devices[i];
                    if (device.kind === 'videoinput') {
                        arrayLista.push(device.deviceId)
                        if ((device.label).includes("back")) {
                            if ((device.label).includes("0")) {
                                deviceFuncional = device.deviceId;
                            }
                        }
                    }
                }
                if (arrayLista.length > 2 && !deviceFuncional) {
                    localStorage.setItem("camarasList", JSON.stringify(arrayLista))
                    setShowSelect(true)
                    setDispositivosVideo(arrayLista)
                    setMsjMultiCamaras(true)
                    deviceFuncional = arrayLista[arrayLista.length - 1];
                }
                console.log("deviceFuncional",deviceFuncional);
                configure(deviceFuncional)
            });
        } else {
            configure(deviceFuncional)
        }

    } */

    const configure = (deviceFuncional) => {
        // setDispositivosActual(deviceFuncional)
        if (stream) {
            stream.getTracks().forEach(track => {
                track.stop();
            })
        }

        const video_constraints = {
            width: { ideal: 640 },
            height: { ideal: 480 },
            advanced: [
                { width: 1280, height: 720 },
                { aspectRatio: 4 / 3 }
            ]
        }

        if (deviceFuncional === 'user' || deviceFuncional === 'environment') {
            video_constraints.facingMode = deviceFuncional;
        } else {
            video_constraints.deviceId = { exact: deviceFuncional };
        }

        const constraints = {
            audio: false,
            video: video_constraints,
        }

        const localStream = navigator.mediaDevices.getUserMedia(constraints)
            .catch(handleErrorMediaUser);

        let width = 320;
        let height = 0;
        localStream.then(function (mediaStream) {
            stream = mediaStream
            refVideo.current.srcObject = mediaStream;
            refVideo.current.onloadedmetadata = function (e) {
                refVideo.current.play();
                if (mediaStream.getVideoTracks().length > 0) {
                    //console.log('disponibles');
                    setErrorVideo(false)
                    setOnLoadViewCamera(false)
                } else {
                    //console.log('No disponibles');    
                    setErrorVideo(true);
                }
            };
            refVideo.current.addEventListener('canplay', function (ev) {
                height = refVideo.current.videoHeight / (refVideo.current.videoWidth / width);
                refCanvas.current.setAttribute('width', refVideo.current.videoWidth * 1.5);
                refCanvas.current.setAttribute('height', refVideo.current.videoHeight * 1.5);
            }, false);
        }).catch(e => {
            console.trace(e);
            setErrorVideo(true);
        })
    }

    const sendData = () => {
        let jsonObj = {};
        jsonObj.ocrFront = JSON.parse(localStorage.getItem('ocrFront'));
        jsonObj.ocrBack = JSON.parse(localStorage.getItem('ocrBack'));
        generarObjetoLifeCycle('pasoInformacion', { status: 'OK', step: 'captura_id_ocr', description: jsonObj }, props);
    }

    const initRecord = (side) => {
        setSide(side);
        setLoading(true);
        setCapturing(true);
        refButtonCapture.current.classList.remove('main_bg_color');
        refButtonCapture.current.classList.remove('gray_bg_color');
        let description = (side === 'front') ? 'CAPTURAR FRENTE' : 'CAPTURAR REVERSO';
        sendEventClick('Captura ID', description, {}, props);
        if (side === 'front') {
            takeFotoFront()
        } else {
            takeFotoBack()
        }
    }

    const takeFotoFront = () => {
        setTimeout(() => {
            let contextCanvas = refCanvas.current.getContext('2d');
            contextCanvas.drawImage(refVideo.current, 0, 0, refVideo.current.videoWidth * 1.5, refVideo.current.videoHeight * 1.5);
            refCanvas.current.toBlob((blob) => {
                //descargarImagen(blob);
                setLoading(false);
                setPreviewId(true);
                setImageUrl(urlCreator.createObjectURL(blob));
                setCapturing(false);
            }, 'image/png', 0.9);
        }, 1350);
    }

    const takeFotoBack = () => {
        setTimeout(() => {
            let contextCanvas = refCanvas.current.getContext('2d');
            contextCanvas.drawImage(refVideo.current, 0, 0, refVideo.current.videoWidth * 1.5, refVideo.current.videoHeight * 1.5);
            refCanvas.current.toBlob((blob) => {
                //descargarImagen(blob);
                setLoading(false);
                setPreviewId(true);
                setImageUrl(urlCreator.createObjectURL(blob));
                setCapturing(false);
            }, 'image/png', 0.9);
        }, 1350);
    }

    const enviarImagen = async (blobImage) => {
        // descargarImagen(blobImage);
        let tipoIdentificacion = '';
        let nombre = '';
        setPreviewId(false);
        setProccessing(true);
        setCapturing(true);
        if (side === 'front') {
            if (ocr) {
                const response = extraerOCR(props, blobImage, side);
                const { status, data } = response
                if (status && status === 200) {
                    if (data.payload.ocrData.ocrFrontIsNotBlank) {
                        data.side = side;
                        evento('Extraer OCR', 'Succes', mapearRespuesta(status, data), true, props);
                        if (data.identificacionElectoral) {
                            tipoIdentificacion = 'INE';
                        }
                        else if (data.identificacionPasaporte) {
                            tipoIdentificacion = 'PASAPORTE';
                        }
                        else if (data.documentoNacionalPeru) {
                            tipoIdentificacion = 'DNI_PERU';
                        }
                        else if (data.identificacionMigratoria) {
                            tipoIdentificacion = 'FMM';
                        }
                        else {
                            tipoIdentificacion = 'INE';
                        }
                        let jsonObj = { 'type_id': tipoIdentificacion };
                        generarObjetoLifeCycle('pasoInformacion', { status: 'OK', step: 'captura_id', description: jsonObj }, props);
                    } else {
                        //that.setState({ errorMessage: 'No se pudo leer correctamente tus datos, por favor vuelve a intentar.', intentsFront: that.state.intentsFront + 1, errorCapture: true, errorF: 'Error en la captura de identificación', token: null, loading: false, proccessing: false, hasResponse: true, capturing: false });
                        //that.statusR();
                        let errorMapeado = mapearError(response);
                        errorMapeado.objetoError.error = `ocrFrontIsNotBlank: ${data.payload.ocrData.ocrFrontIsNotBlank}`;
                        evento('Extraer Ocr', errorMapeado.tipoError, errorMapeado.objetoError, false, props);
                    }
                } else {
                    let errorMapeado = mapearError(response);
                    evento('Extraer Ocr', errorMapeado.tipoError, errorMapeado.objetoError, false, props);
                }
            }
            if (fullOcr) {
                try {
                    const response = await extraerOCRCompleto(props, blobImage, side, isIOS, isMobile);
                    const { status, data } = response;
                    setDataResponse(data);
                    if (status && status === 200) {
                        if (data.payload.ocrData) {
                            data.payload.ocrData.side = side;
                            evento('Captura ID', 'Succes', mapearRespuesta(status, data), true, props);
                            const ocrMapeado = mapearOCR(data.payload.ocrData, 'front');
                            let tipo = ocrMapeado.type;
                            let jsonObj = { 'type_id': tipo };
                            localStorage.setItem('typeID', tipo.toLowerCase());
                            generarObjetoLifeCycle('pasoInformacion', { status: 'OK', step: 'captura_id', description: jsonObj }, props);
                            if (tipo === 'PASAPORTE') {
                                setLoading(false);
                                setCapturing(false);
                                sendData();
                                setTimeout(() => {
                                    setProccessing(false);
                                    history.push({
                                        pathname: nextStep,
                                        state: { passport: false }
                                    })
                                }, 300);
                            } else {
                                if (ocrMapeado.full_name) {
                                    // if (ocrMapeado.dni) {
                                        // if (ocrMapeado.dni.length < 3 || ocrMapeado.full_name.length < 10) {
                                        if (ocrMapeado.full_name.length < 10) {
                                            if (intentsData < intentosFrente) {
                                                localStorage.setItem('intentsData', 'OCR');
                                                setLoading(false);
                                                setProccessing(false);
                                                setSide('back');
                                                setIntentsFront(0);
                                                setIntentsData(0);
                                                setCapturing(false);
                                            } else {
                                                setLoading(false);
                                                setProccessing(false);
                                                setIntentsData(intentsData + 1);
                                                setErrorF('Datos no cumplen con formato');
                                                setHasResponse(true);
                                                setCapturing(false);
                                            }
                                        } else {
                                            setLoading(false);
                                            setProccessing(false);
                                            setSide('back');
                                            setIntentsFront(0);
                                            setIntentsData(0);
                                            setCapturing(false);
                                        }
                                    } else {
                                        if (ocrMapeado.full_name.length < 10) {
                                            if (intentsData < intentosFrente) {
                                                localStorage.setItem('intentsData', 'OCR');
                                                setLoading(false);
                                                setProccessing(false);
                                                setSide('back');
                                                setIntentsFront(0);
                                                setIntentsData(0);
                                                setCapturing(false);
                                            } else {
                                                setLoading(false);
                                                setProccessing(false);
                                                setIntentsData(intentsData + 1);
                                                setErrorF('Datos no cumplen con formato');
                                                setHasResponse(true);
                                                setCapturing(false);
                                            }
                                        }else {
                                            setLoading(false);
                                            setProccessing(false);
                                            setSide('back');
                                            setIntentsFront(0);
                                            setIntentsData(0);
                                            setCapturing(false);
                                        }
                                    } 
                            }
                            if (intentsFront === Number(obtenerValorConfig(dataOtorgante, 'INTENTOS_ID_FRONTAL', '3')) && hasFace) {
                                if (tipo === 'PASAPORTE') {
                                    setLoading(false);
                                    setCapturing(false);
                                    sendData()
                                    setTimeout(() => {
                                        setProccessing(false);
                                        history.push({
                                            pathname: nextStep,
                                            state: { passport: false }
                                        })
                                    }, 300);
                                } else {
                                    setCapturing(false);
                                    setProccessing(false);
                                    setSide('back');
                                    setCapturing(false);
                                }
                            }
                            setLoading(false);
                            setProccessing(false);
                            setHasResponse(true);
                            setCapturing(false);
                        } else {
                            let errorMapeado = mapearError(data);
                            errorMapeado.objetoError.error = `ocrFrontIsNotBlank: ${data.payload.ocrData.ocrFrontIsNotBlank}`;
                            evento('Captura ID', errorMapeado.tipoError, errorMapeado.objetoError, false, props)
                            setErrorMessage('Por favor asegúrate que tu cámara este limpia y mantén firme  e intenta nuevamente.');
                            setIntentsFront(intentsFront + 1);
                            setErrorCapture(true);
                            setErrorF('Error en la captura de identificación');
                            setLoading(false);
                            setProccessing(false);
                            setHasResponse(true);
                            setCapturing(false);
                        }
                    } else {
                        let errorMapeado = mapearError(response);
                        evento('Captura ID', errorMapeado.tipoError, errorMapeado.objetoError, false, props);
                        if (response.response) {
                            console.log("response", response.response);
                            setErrorMessage('Por favor asegúrate que tu cámara este limpia y mantén firme  e intenta nuevamente.');
                            setIntentsFront(intentsFront + 1);
                            setErrorCapture(true);
                            setErrorF('Error en la captura de identificación');
                            setLoading(false);
                            setProccessing(false);
                            setHasResponse(true);
                            setCapturing(false);
                        } else {
                            if (response.toString().includes('Network')) {
                                setErrorMessage('Revisa tu conexión a internet e intenta nuevamente.');
                                setErrorCapture(true);
                                setErrorF('Error en la captura de identificación');
                                setLoading(false);
                                setProccessing(false);
                                setHasResponse(true);
                                setCapturing(false);
                            } else {
                                setErrorMessage('Por favor asegúrate que tu cámara este limpia y mantén firme  e intenta nuevamente.');
                                setErrorCapture(true);
                                setErrorF('Error en la captura de identificación');
                                setLoading(false);
                                setProccessing(false);
                                setHasResponse(true);
                                setCapturing(false);
                            }
                        }
                    }
                } catch (error) {
                    let errorMapeado = mapearError(error);
                    evento('Captura ID', errorMapeado.tipoError, errorMapeado.objetoError, false, props);
                    if (error.response) {
                        setErrorMessage('Por favor asegúrate que tu cámara este limpia y mantén firme  e intenta nuevamente.');
                        setIntentsFront(intentsFront + 1);
                        setErrorCapture(true);
                        setErrorF('Error en la captura de identificación');
                        setLoading(false);
                        setProccessing(false);
                        setHasResponse(true);
                        setCapturing(false);
                    } else {
                        if (error.toString().includes('Network')) {
                            setErrorMessage('Revisa tu conexión a internet e intenta nuevamente.');
                            setErrorCapture(true);
                            setErrorF('Error en la captura de identificación');
                            setLoading(false);
                            setProccessing(false);
                            setHasResponse(true);
                            setCapturing(false);
                        } else {
                            setErrorMessage('Por favor asegúrate que tu cámara este limpia y mantén firme  e intenta nuevamente.');
                            setErrorCapture(true);
                            setErrorF('Error en la captura de identificación');
                            setLoading(false);
                            setProccessing(false);
                            setHasResponse(true);
                            setCapturing(false);
                        }
                    }
                }
            }
            if (classify) {
                if (!fullOcr && !ocr) {
                    extraerOCR(props, blobImage, side).then(async ({ status, data, data: { payload: { ocrData } } }) => {
                        if (status === 200) {
                            if (ocrData.ocrFrontIsNotBlank) {
                                try {
                                    nombre = side + "-" + (new Date().getTime()) + ".png";
                                    const response = await enviarImagenIdentificacion(props, blobImage, 'ine', nombre, side);
                                    const { status, data } = response;
                                    if (status && status === 200) {
                                        data.side = side;
                                        evento('Evaluación Imagen Frente', 'Succes', mapearRespuesta(status, data), true, props);
                                    } else {
                                        let errorMapeado = mapearError(response);
                                        evento('Evaluación Imagen Frente', errorMapeado.tipoError, errorMapeado.objetoError, false, props);
                                    }
                                } catch (error) {
                                    let errorMapeado = mapearError(error);
                                    evento('Evaluación Imagen Frente', errorMapeado.tipoError, errorMapeado.objetoError, false, props);
                                }
                                if (ocrData.identificacionElectoral) {
                                    tipoIdentificacion = 'INE';
                                }
                                else if (ocrData.identificacionPasaporte) {
                                    tipoIdentificacion = 'PASAPORTE';
                                }
                                else if (ocrData.documentoNacionalPeru) {
                                    tipoIdentificacion = 'DNI_PERU';
                                }
                                else if (ocrData.identificacionMigratoria) {
                                    tipoIdentificacion = 'FMM';
                                }
                                else {
                                    tipoIdentificacion = 'INE';
                                }
                                let jsonObj = { 'type_id': tipoIdentificacion };
                                generarObjetoLifeCycle('pasoInformacion', { status: 'OK', step: 'captura_id', description: jsonObj }, props);
                            } else {
                                let errorMapeado = mapearError(data);
                                errorMapeado.objetoError.error = `ocrFrontIsNotBlank: ${ocrData.ocrFrontIsNotBlank}`;
                                evento('Extraer Ocr', errorMapeado.tipoError, errorMapeado.objetoError, false, props);
                            }
                        }
                    }).catch(error => {
                        let errorMapeado = mapearError(error);
                        evento('Captura ID', errorMapeado.tipoError, errorMapeado.objetoError, false, props);

                    });
                } else {
                    try {
                        nombre = side + "-" + (new Date().getTime()) + ".png";
                        const response = await enviarImagenIdentificacion(props, blobImage, 'ine', nombre, side);
                        const { status, data } = response;
                        if (status && status === 200) {
                            data.side = side;
                            evento('Evaluación Imagen Frente', 'Succes', mapearRespuesta(status, data), true, props);
                        } else {
                            let errorMapeado = mapearError(response);
                            evento('Evaluación Imagen Frente', errorMapeado.tipoError, errorMapeado.objetoError, false, props);
                        }

                    } catch (error) {
                        let errorMapeado = mapearError(error);
                        evento('Evaluación Imagen Frente', errorMapeado.tipoError, errorMapeado.objetoError, false, props);
                    }
                }
            }
        } else {
            if (ocr) {
                const response = extraerOCR(props, blobImage, side);
                const { status, data } = response
                if (status && status === 200) {
                    if (data.payload.ocrData.ocrFrontIsNotBlank) {
                        data.side = side;
                        evento('Captura ID', 'Succes', mapearRespuesta(status, data), true, props);
                    } else {
                        let errorMapeado = mapearError(response);
                        errorMapeado.objetoError.error = `ocrFrontIsNotBlank: ${data.payload.ocrData.ocrFrontIsNotBlank}`;
                        evento('Extraer Ocr', errorMapeado.tipoError, errorMapeado.objetoError, false, props);
                    }
                } else {
                    let errorMapeado = mapearError(response);
                    evento('Extraer Ocr', errorMapeado.tipoError, errorMapeado.objetoError, false, props);
                }
            }
            if (classify) {
                try {
                    nombre = side + "-" + (new Date().getTime()) + ".png";
                    const response = await enviarImagenIdentificacion(props, blobImage, 'ine', nombre, side);
                    const { status, data } = response;
                    if (status && status === 200) {
                        data.side = side;
                        evento('Evaluación Imagen Frente', 'Succes', mapearRespuesta(status, data), true, props);
                    } else {
                        let errorMapeado = mapearError(response);
                        evento('Evaluación Imagen Frente', errorMapeado.tipoError, errorMapeado.objetoError, false, props);
                    }

                } catch (error) {
                    let errorMapeado = mapearError(error);
                    evento('Evaluación Imagen Frente', errorMapeado.tipoError, errorMapeado.objetoError, false, props);
                }
            }
            if (fullOcr) {
                try {
                    const response = await extraerOCRCompleto(props, blobImage, side, isIOS, isMobile);
                    const { status, data } = response;
                    setDataResponse(data);
                    if (status && status === 200) {
                        if (data.payload.ocrData) {
                            data.payload.ocrData.side = side;
                            evento('Captura ID', 'Succes', mapearRespuesta(status, data), true, props);
                            mapearOCR(data.payload.ocrData, 'back');
                            setLoading(false);
                            setCapturing(false);
                            sendData();
                            setTimeout(() => {
                                setProccessing(false);
                                history.push({
                                    pathname: nextStep,
                                    state: { passport: false }
                                })
                            }, 300);
                        } else {
                            let errorMapeado = mapearError(data);
                            errorMapeado.objetoError.error = `ocrBackIsNotBlank: ${data.payload.ocrData.ocrBackIsNotBlank}`;
                            evento('Captura ID', errorMapeado.tipoError, errorMapeado.objetoError, false, props)
                            setErrorMessage('Por favor asegúrate que tu cámara este limpia y mantén firme  e intenta nuevamente.');
                            setIntentsBack(intentsBack + 1);
                            setErrorCapture(true);
                            setErrorF('Error en la captura de identificación');
                            setLoading(false);
                            setProccessing(false);
                            setHasResponse(true);
                            setCapturing(false);
                        }
                    } else {
                        let errorMapeado = mapearError(response);
                        evento('Captura ID', errorMapeado.tipoError, errorMapeado.objetoError, false, props);
                        if (response.response) {
                            setErrorMessage('Por favor asegúrate que tu cámara este limpia y mantén firme  e intenta nuevamente.');
                            setErrorCapture(true);
                            setErrorF('Error en la captura de identificación');
                            setLoading(false);
                            setProccessing(false);
                            setHasResponse(true);
                            setCapturing(false);
                            if (response.response.status === 400) {
                                setIntentsBack(intentsBack + 1);
                            }
                        } else {
                            // if (response.toString().includes('Network')) {
                                if (errorMapeado.objetoError.error === "Network Error" || errorMapeado.objetoError.error === "timeout of 40000ms exceeded") {
                                setErrorMessage('Revisa tu conexión a internet e intenta nuevamente.');
                                setErrorCapture(true);
                                setErrorF('Error en la captura de identificación');
                                setLoading(false);
                                setProccessing(false);
                                setHasResponse(true);
                                setCapturing(false);
                            } else {
                                setErrorMessage('Por favor asegúrate que tu cámara este limpia y mantén firme  e intenta nuevamente.');
                                setErrorCapture(true);
                                setErrorF('Error en la captura de identificación');
                                setLoading(false);
                                setProccessing(false);
                                setHasResponse(true);
                                setCapturing(false);
                            }
                        }
                    }
                } catch (error) {
                    let errorMapeado = mapearError(error);
                    evento('Captura ID', errorMapeado.tipoError, errorMapeado.objetoError, false, props);
                    if (error.response) {
                        setErrorMessage('Por favor asegúrate que tu cámara este limpia y mantén firme  e intenta nuevamente.');
                        setIntentsBack(intentsBack + 1);
                        setErrorCapture(true);
                        setErrorF('Error en la captura de identificación');
                        setLoading(false);
                        setProccessing(false);
                        setHasResponse(true);
                        setCapturing(false);
                    } else {
                        // if (error.toString().includes('Network')) {
                            if (errorMapeado.objetoError.error === "Network Error" || errorMapeado.objetoError.error === "timeout of 40000ms exceeded") {
                            setErrorMessage('Revisa tu conexión a internet e intenta nuevamente.');
                            setErrorCapture(true);
                            setErrorF('Error en la captura de identificación');
                            setLoading(false);
                            setProccessing(false);
                            setHasResponse(true);
                            setCapturing(false);
                        } else {
                            setErrorMessage('Por favor asegúrate que tu cámara este limpia y mantén firme  e intenta nuevamente.');
                            setErrorCapture(true);
                            setErrorF('Error en la captura de identificación');
                            setLoading(false);
                            setProccessing(false);
                            setHasResponse(true);
                            setCapturing(false);
                        }
                    }
                }
            }
        }
    }

    const cancelarCapturaIdentificacion = () => {
        sendEventClick('Captura ID', 'CANCELAR', {}, props);
        history.push('/preparacion_identificacion');
    }

    const descargarImagen = (blob) => {
        let url = URL.createObjectURL(blob);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = 'captura_ine.png';
        a.click();
    }

    const enviarReintento = (step, description) => {
        generarObjetoLifeCycle('reintento', { status: 'RETRY', step: step, description: description }, props);
    }

    const finalizarFlujo = async () => {
        setErrorCapture(false);
        setMostrarLoader(true);
        await generateZip(props, 'SEMAFORO', 'red', isIOS);
        localStorage.setItem('bloqueo', 'true');
        let newDate = new Date().getTime();
        let acceptDta = new Date();
        acceptDta.setTime(newDate + (60 * 60 * 1000))
        localStorage.setItem('time', acceptDta.getTime())
        let res = convertdataJSON();
        let event_t = await JSON.stringify(res);
        let json_final = {
            'status': 'FAIL',
            'step': 'captura_id',
            'stepEvent': 'finished',
            'description': event_t,
            'response': dataResponse,
            'bandera': 'red',
        }
        await flowIncompleted(props, json_final);
        localStorage.setItem('completado', 'true')
        setMostrarLoader(false)
        setDisableFinishButton(false)
    }

    const convertdataJSON = () => {
        let jsonObj = {};
        jsonObj.uuidUser = localStorage.getItem('uuidUser') || '';
        jsonObj.uuidTrx = localStorage.getItem('uuidTrx') || '';
        jsonObj.ocrFront = JSON.parse(localStorage.getItem('ocrFront')) || {};
        jsonObj.ocrBack = JSON.parse(localStorage.getItem('ocrBack')) || {};
        jsonObj.data_user = JSON.parse(localStorage.getItem('data_user')) || {};
        jsonObj.links = JSON.parse(localStorage.getItem('links')) || {};
        return jsonObj;
    }

    const setCanvasScalingFactor = () => {
        return window.devicePixelRatio || 1;
    }

    const resizeCanvas = () => {
        //Gets the devicePixelRatio
        let width = 0;
        let pixelRatio = setCanvasScalingFactor();

        //The viewport is in portrait mode, so let width should be based off viewport WIDTH
        if (window.innerHeight > window.innerWidth) {
            //Makes the canvas 100% of the viewport width
            width = Math.round(1.0 * window.innerWidth);
        }
        //The viewport is in landscape mode, so let width should be based off viewport HEIGHT
        else {
            //Makes the canvas 100% of the viewport height
            width = Math.round(1.0 * window.innerHeight);
        }

        //This is done in order to maintain the 1:1 aspect ratio, adjust as needed
        let height = width;

        //This will be used to downscale the canvas element when devicePixelRatio > 1
        refContainerCanvasMask.current.style.width = width + "px";
        // refContainerCanvasMask.current.style.height = height + "px";

        refCanvasMask.current.width = width * pixelRatio;
        refCanvasMask.current.height = height * pixelRatio;
    }

    const handleErrorMediaUser = (error) => {
        if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
            //required track is missing 
            evento('Captura ID', 'User Media', { error: error.name, status: 'NO SE ENCONTRO DISPOSITIVO Y/O TRACK' }, true, props);
        } else if (error.name === 'NotReadableError' || error.name === 'TrackStartError') {
            //webcam or mic are already in use 
            evento('Captura ID', 'User Media', { error: error.name, status: 'LOS DISPOSITVOS SOLICITADOS ESTÁN EN USO' }, true, props);
        } else if (error.name === 'OverconstrainedError' || error.name === 'ConstraintNotSatisfiedError') {
            //constraints can not be satisfied by avb. devices 
            evento('Captura ID', 'User Media', { error: error.name, status: 'EL DISPOSITIVO NO PUEDE ALCANZAR LOS CONSTRAINTS' }, true, props);
        } else if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
            //permission denied in browser 
            evento('Captura ID', 'User Media', { error: error.name, status: 'PERMISOS DENEGADOS' }, true, props);
        } else if (error.name === 'TypeError' || error.name === 'TypeError') {
            //empty constraints object 
            evento('Captura ID', 'User Media', { error: error.name, status: 'CONSTRAINTS VACÍOS' }, true, props);
        } else {
            //other errors 
            evento('Captura ID', 'User Media', { error: error.toString(), status: 'OTRO TIPO DE ERROR' }, true, props);
        }
        setErrorVideo(true);
    }

    const redirect = () => {
        if (validarRedireccionamiento(dataOtorgante)) {
            setTimeout(() => {
                history.push(`/${apikey}`);
                setLoading(false);
            }, 300);
        } else {
            setShowCancelScreen(true)
        }
    }

    return (
        <>
            <div className='module_container desk_id_capture' style={{ position: 'fixed' }}>
                <div className='camera_capture_frame'>
                    <video ref={refVideo} id='video_wrt' playsInline></video>
                    <canvas ref={refCanvas} id='canvas_wrt_environment' hidden></canvas>
                </div>
                <div className="main_container">
                    <div className="instruction_container">
                        {(!previewId && <>
                            <div className='module_title animate__animated animate__slideInDown'>
                                <p>Coloca tu identificación  de <b>{side === 'front' ? 'frente' : 'reverso'}</b></p>
                            </div>
                            <div className='alert_instruction animate__animated animate__fadeIn animate__delay-1s'>
                                <img height='24' src={process.env.PUBLIC_URL + 'images/evita_reflejos_warn.png'} alt='' />
                            </div>
                        </>)}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', flex: '1 1' }}>
                        <div className={(isMobile) ? 'div-side-mask_container': 'div-side-mask_container width-desk'}></div>
                        <div className="mask_container" ref={refContainerCanvasMask}>
                            {(previewId) ? ('') : isMobile ?
                                <>
                                    <canvas className='mask_canvas' ref={refCanvasMask}></canvas>
                                </>
                                 :
                                <>
                                    <canvas className='mask_canvas' ref={refCanvasMask}></canvas>
                                </>
                            } 
                        </div>
                        <div className={(isMobile) ? 'div-side-mask_container': 'div-side-mask_container width-desk'}></div>
                    </div>

                    <div className="buttons_container">
                        {intentsFront <= Number(obtenerValorConfig(dataOtorgante, 'INTENTOS_ID_FRONTAL', '3')) && !previewId && !showHelp && (<div className='module_buttons_mask animate__animated animate__fadeIn animate__delay-2s'>
                            {
                                (showSelect && side === 'front' && !proccessing) &&
                                <select className="forcewidth100 selectCamaras" onChange={(event) => configure(event.target.value)}>
                                    <option key="0" disabled={true} >Selecciona la mejor cámara aquí</option>
                                    {dispositivosVideo.map((camara, index) => {
                                        return (
                                            <option key={index} value={camara} selected={(camara[camara.length - 1] === index) ? "true" : "false"}>Cámara {index + 1}</option>
                                        );
                                    })}
                                </select>
                            }
                            {side === 'front' ? <button ref={refButtonCapture} type='button' onClick={() => initRecord('front')} className={['btn btn-raised btn-primary forcewidth100 ', (capturing ? 'gray_bg_color' : 'main_bg_color'), (isMobile) ? '' : 'desk_id_capture_btn'].join(' ')} disabled={proccessing || loading}>{(proccessing || loading ? 'PROCESANDO...' : 'CAPTURAR FRENTE')}</button> : <button ref={refButtonCapture} type='button' onClick={() => initRecord('back')} className={['btn btn-raised btn-primary forcewidth100 ', (capturing ? 'gray_bg_color' : 'main_bg_color'), (isMobile) ? '' : 'desk_id_capture_btn'].join(' ')} disabled={proccessing || loading}>{(proccessing || loading ? 'PROCESANDO...' : 'CAPTURAR REVERSO')}</button>}
                            {((side === 'back') || (!showSelect)) && <button type='button' onClick={() => cancelarCapturaIdentificacion()} className={['btn btn-raised btn-primary forcewidth100 cancel_btn main_color', (isMobile) ? '' : 'desk_id_capture_btn'].join(' ')} disabled={proccessing || loading}>CANCELAR</button>}
                        </div>)}
                    </div>
                </div>
            </div>
            {((desktop && showIdOverlay) && <div className='id_hold show_id_hold'>
                <div className='center_info_bx'>
                    <img src={process.env.PUBLIC_URL + '/images/componente_captura_identificacion/id_hold_icon.png'} height='200' alt='' />
                    <p>Toma tu identificación solo con dos dedos <br /> sin obstruir tu foto u otra información<br />
                        <small>Sugerimos tomarla de la esquina superior izquierda</small>
                    </p>
                    <br />
                    <button type='button' className='btn btn-raised btn-primary forcewidth100 main_bg_color' onClick={() => { setShowIdOverlay(false); sendEventClick('Captura ID', 'ENTENDIDO EMPEZAR', {}, props); }}>ENTENDIDO EMPEZAR</button>
                </div>
            </div>)}

            {(intentsFront >= Number(obtenerValorConfig(dataOtorgante, 'INTENTOS_ID_FRONTAL', '3'))) && (<div className='err_finale  animate__animated animate__slideInUp'>
                <div className='center_checks'>
                    <h5>Proceso no exitoso</h5>
                    <p>Has superado el número <b>máximo</b> de intentos para este proceso inténtalo nuevamente <b>más tarde</b>.</p>
                    <p>Si deseas mayor información no dudes en contactarnos con el <b>ID</b> de proceso <b>{(uuidTransaccion).split('-')[0]}</b> </p>
                    <br />
                    {
                        (pathname === '/Cw2qjkHFRvpLPryvUWXDcOPMEgHIYI9X') &&
                        <div className='container'>
                            <div className='row'>
                                <div className='col'>
                                    <p><b>Llámanos al:</b></p>
                                    <p><a className='help_phone' href={'tel:' + obtenerValorConfig(dataOtorgante, 'TEL_CONTACTO_PRINCIPAL')}>{obtenerValorConfig(dataOtorgante, 'TEL_CONTACTO_PRINCIPAL')}</a></p>
                                </div>
                                <div className='col'>
                                    <p><b>Escríbenos a:</b></p>
                                    <p><a className='help_mail' href={'mailto:' + obtenerValorConfig(dataOtorgante, 'EMAIL_CONTACTO_PRINCIPAL')}>{obtenerValorConfig(dataOtorgante, 'EMAIL_CONTACTO_PRINCIPAL')}</a></p>
                                </div>
                            </div>
                        </div>
                    }
                    {(!window.opener) &&
                        <div className='action_buttons noscroll_screen'>
                            <button className='btn btn-raised btn-primary forcewidth100 main_bg_color' disabled={disableFinishButton} onClick={redirect}>ENTENDIDO</button>
                        </div>
                    }
                </div>
            </div>)}

            {(proccessing) && <LoaderOCR side={side} show={() => setShowHelp(true)} dataOtorgante={dataOtorgante} />}

            {mostrarLoader && <Loader/>}

            {((loading) && <div className='sprite_stay_a animado'></div>)}
            {((intentsData === 1) || errorCapture) &&
                <div className='overlay_box'>
                    <div className='alert_box'>
                        <p className='animate__animated animate__slideInDown'>{errorMessage}</p>
                        <button type='button' onClick={(e) => {
                            setIntentsData(2);
                            setErrorCapture(false);
                        }} className='btn btn-raised btn-primary forcewidth100 main_bg_color alert_btn  animate__animated animate__fadeIn animate__delay-2s'>VOLVER A INTENTAR</button>
                    </div>
                </div>}
            {(errorMsg) &&
                <div className='overlay_box'>
                    <div className='alert_box'>
                        <p className='animate__animated animate__slideInDown'>Se ha detectado un bloqueo de red, verifica tu conexión de internet</p>
                        <button type='button' onClick={(e) => {
                            setErrorMsg(false);
                        }} className='btn btn-raised btn-primary forcewidth100 main_bg_color alert_btn  animate__animated animate__fadeIn animate__delay-2s'>VOLVER A INTENTAR</button>
                    </div>
                </div>}
            {(errorVideo) &&
                <div className='overlay_box'>
                    <div className='alert_box'>
                        <p className='animate__animated animate__slideInDown'>Hemos detectado que la <b>cámara de tu dispositivo</b> está en uso, por favor asegúrate de <b>cerrar las pestañas</b> abiertas e inténtalo nuevamente.</p>
                        <button type='button' onClick={(e) => {
                            setErrorVideo(false);
                            window.location.reload();
                        }} className='btn btn-raised btn-primary forcewidth100 main_bg_color alert_btn  animate__animated animate__fadeIn animate__delay-2s'>VOLVER A INTENTAR</button>
                    </div>
                </div>}
            {previewId && <ComponenteRecorte
                tipo='identificacion'
                imageUrl={imageUrl}
                enviarImagen={blobImage => enviarImagen(blobImage)}
                reload={() => { setPreviewId(false); setCapturing(false); sendEventClick('Captura ID', 'CAPTURAR DE NUEVO', {}, props); }}
                side={side}
                configuration={props}
                setShowAlertDimensions={setShowAlertDimensions}
            />}
            {showHelp && <Ayuda hide={() => setShowHelp(false)} />}
            {/* {msjMultiCamaras && <MultiCamara setMsjMultiCamaras={setMsjMultiCamaras} />} */}
            {onLoadViewCamera && <OverlayCargandoCamara />}
            {showAlertDimensions && <AlertaValidacionDimensiones setShowAlertDimensions={setShowAlertDimensions} />}
            {showCancelScreen && <CancelarFlujo uuidTransaccion={uuidTransaccion} dataOtorgante={dataOtorgante} estado={'fallido'} />}
        </>
    );
}

export default withOrientationChange(ComponenteCapturaIdentificacion);
